import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../IconLabel';
import { InputField } from '../InputField';

import classNames from 'classnames';
import classes from './SearchField.module.scss';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchField: FunctionComponent<SearchFieldProps> = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(classes['search-field'], className)}>
      <InputField
        value={value}
        placeholder={placeholder}
        inputClassName={classes['search-field__input']}
        onChange={({ target }) => onChange(target.value)}
      />
      <IconLabel
        className={classes['search-field__icon']}
        iconId={'search'}
        iconSize={20}
        color={'#b3b3b3'}
        singleColor
        nonClickable
      />
      {value && (
        <IconLabel
          className={classes['search-field__clear']}
          iconId={'close'}
          ariaLabel={t('common.clear')}
          onClick={() => onChange('')}
          singleColor
        />
      )}
    </div>
  );
};
